import styled, { css } from 'styled-components';

const BannerStyled = styled.div.attrs({
  className: 'banner',
})`
  ${({ theme, iconColor, isNetflixBanner, iconBg, displayStyle }) => {
    const { colors, media } = theme;

    return css`
      border-radius: 10px;
      display: flex;
      flex: 1 1 auto;
      order: 1;
      margin-top: 32px;
      margin-left: 4px;
      background-color: ${colors.primary.white};
      box-shadow: 0 0.25rem 0.25rem rgba(0 0 0 / 20%);
      ${media.tablet.up} {
        flex-wrap: nowrap;
        margin-top: 0;
        order: 0;
        flex: 0 1 415px;
        width: 352px;
        margin-bottom: 24px;
      }

      ${media.desktop.only} {
        width: ${isNetflixBanner ? '450px' : '500px'};
        flex: 0 1 auto;
      }

      .banner {
        &__icon-wrapper {
          border-radius: 10px 0px 0px 10px;
          border: 1px solid ${colors.primary[iconBg] || colors.primary.celeste};
          background-color: ${colors.primary[iconBg] || colors.primary.celeste};
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px;
        }

        &__icon-wrapper-default {
          border: 1px solid ${colors.primary[iconBg] || colors.primary.celeste};
          background-color: ${colors.primary[iconBg] || colors.primary.celeste};
        }

        &__icon-wrapper-holiday {
          border:1px solid red;
          background: repeating-linear-gradient( -45deg, ${colors.primary.red}, ${colors.primary.red} 10px, ${colors.primary.darkRed}  10px, ${colors.primary.darkRed} 23px)
        }


        &__icon {
          width: ${isNetflixBanner ? 'auto' : '36px'};
          height: ${isNetflixBanner ? 'auto' : '36px'};
          align-self: center;
          margin: ${isNetflixBanner ? '0' : '0px 8px'};

          path {
            fill: ${isNetflixBanner ? 'auto' : (colors.primary[iconColor] || colors.primary.darkBlue)};
          }

          &.large {
            width: 56px;
            height: 56px;
            margin: 0;
          }
        }
        &__text-block {
          display: flex;
          color: ${colors.primary.lightBlack};
          font-size: 14px;
          margin: 16px;
          align-items: center;

          ${media.tablet.up} {
            margin: 15px;
          }
        }
        &__text-bottom {
          line-height: 16px;

          b {
            font-weight: 700;
            margin-top: 4px;
            ${media.tablet.up} {
              margin-top: 0;
            }
          }
        }
        &__text-netflix {
          background: transparent;
          border: none;
          color: ${colors.primary.darkBlue};
          cursor: pointer;
          font-weight: 700;
          padding: 0;
          text-decoration: underline;
        }
      }

      ${
        displayStyle === 'nflst' &&
        css`
        .banner__text-block {
          align-items: normal;
          display: flex;
          flex-direction: column;

          ${media.tablet.up} {
            gap: 16px;
            padding-top: 12px;
            padding-bottom: 12px;
          }
        }
        .banner__disclaimer {
          font-size: 10px;

          ${media.mobile.down} {
            margin-top: 10px;
          }
        }
        `
      }
    `;
  }}
`;

export default BannerStyled;
